module.exports = __webpack_public_path__ + "static/media/8798.7fc14426.png";